import { useTranslation } from "../../../../../context/TranslationContext";

const DeductionsDetails = ({ deductionDetails }) => {
  const { t } = useTranslation();
  return (
    <>
      {(deductionDetails?.vendor_deduction && deductionDetails?.vendor_deduction > 0) || (deductionDetails?.pickupvendor_deduction && deductionDetails?.pickupvendor_deduction > 0) ? <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <h2 className="font-semibold text-base mb-3">{t("deductionsDetail")}</h2>
        <div className="flex">
          <div className="flex flex-col gap-2">
            {
              deductionDetails?.pickupvendor_deduction && deductionDetails?.pickupvendor_deduction > 0 ? (
                <h3 className="text-sm font-semibold flex gap-2">
                  {t("deductionsAmountForHost")}
                  <span className=" font-normal text-[#222222]">
                    {deductionDetails?.pickupvendor_deduction} SAR
                  </span>
                </h3>
              ) : null
            }
            {
              deductionDetails?.vendor_deduction && deductionDetails?.vendor_deduction > 0 ? (
                <h3 className="text-sm font-semibold flex gap-2">
                  {t("deductionsAmountForSeller")}
                  <span className=" font-normal text-[#222222]">
                    {deductionDetails?.vendor_deduction} SAR
                  </span>
                </h3>
              ) : null
            }
            <p className=" text-sm pt-[4px] text-[#222222]">
              <strong>{t("deductionsReason")}</strong><br />
              {deductionDetails?.reason}
            </p>
          </div>
        </div>
      </div>: null}
    </>
  );
};
export default DeductionsDetails;
